import axios from "axios";
import { config } from "../config/config";

const baseUrl = config.apiUrl;

const Apimanager = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

Apimanager.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Token ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

Apimanager.interceptors.response.use(
  (res) => {
    return res;
  },
  async (err) => {
    if (err.response.status === 403) {
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export default Apimanager;
